import React from "react";
import { Sidebar } from "../../components/Sidebar";
import GreenMilesPageHeader from "../../components/GreenMiles/Home/GreenMilesPageHeader";
import GreenMilesHotelsTable from "../../components/GreenMiles/Home/GreenMilesHotelsTable";

/**
 * Parc GreenMiles.
 *
 * La page ne fait plus aucun appel : elle bloquait sur `useGreenMilesHotels`
 * (GET /greenmiles/hotels) dont le résultat n'était utilisé nulle part — GreenMilesHotelsTable
 * est monté sans props et charge ses propres données, en deux temps (liste puis stats).
 */
const GreenMilesHome = () => {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-4 overflow-auto">
        <GreenMilesPageHeader />
        <GreenMilesHotelsTable />
      </div>
    </div>
  );
};

export default GreenMilesHome;
